module.exports = __webpack_public_path__ + "static/media/r_logo_with_name.a2b624fe.png";